import React, { useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import '../../assets/style/Modal.css';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import ModalHeader from '../../components/ModalHeader';
import { CLICK_ACTIONS } from '../../utils/Constant';
import CenterSpinner from '../../components/CenterSpinner';
import { toast } from 'react-toastify';
import {
  formattedDateWithFormat,
  isAPIFailed,
  isAPISuccess,
} from '../../utils/Util';
import { useAppDispatch } from '../../store/redux-hooks';
import ViewRemunerationDetails from '../../components/ViewRemunerationDetails';
import { approveOrRejectRemuneration } from '../../features/remunerationSlice';

interface IApproveModalProps {
  isOpen: boolean;
  remunerationDetails: any;
  toggleApproveModal: (action: string) => void;
  durationMonth: Date;
}

const ViewRemunerationModal: React.FunctionComponent<IApproveModalProps> = ({
  isOpen,
  remunerationDetails,
  toggleApproveModal,
  durationMonth,
}: IApproveModalProps) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [comment, setComment] = useState<string>('');

  const onAction = (action: string) => {
    const data = {
      candidateId: [remunerationDetails.candidateId],
      status: action === CLICK_ACTIONS.APPROVE ? 0 : 1,
      comments: comment,
      approvedMonth: formattedDateWithFormat(String(durationMonth), 'MM-YYYY'),
    };
    setShowLoader(true);
    dispatch(approveOrRejectRemuneration(data))
      .then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled.payload)) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
          toggleApproveModal(CLICK_ACTIONS.REFRESH_LIST);
        }
      })
      .catch(() => {
        setShowLoader(false);
        if (action === CLICK_ACTIONS.APPROVE) {
          toast.error('Candidate remuneration approve failed!');
        } else if (action === CLICK_ACTIONS.REJECT) {
          toast.error('Candidate remuneration rejection failed!');
        }
      });
  };
  const getCommentAndAction = () => (
    <>
      <div className=" my-2 mx-4 rounded">
        <div className="mb-3">
          <Row>
            <Col md={6} xs={12}>
              <FormGroup>
                <Label for="comment" className="model-comment-title">
                  Comments, If any
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  maxLength={250}
                  value={comment}
                  placeholder="Please enter your comments here"
                  className="rounded border model-comment-area"
                  onChange={(event) => setComment(event.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <Button
          variant="primary"
          className="m-1 cl-btn-primary"
          onClick={() => {
            onAction(CLICK_ACTIONS.APPROVE);
          }}
        >
          Approve
        </Button>
        <Button
          variant="outline-primary"
          className="m-1 cl-btn-outline-primary"
          onClick={() => {
            onAction(CLICK_ACTIONS.REJECT);
          }}
        >
          Reject
        </Button>
      </div>
    </>
  );

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleApproveModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white p-2 rounded border">
        <ModalHeader
          photoUrl={remunerationDetails.photo}
          toggle={() => {
            toggleApproveModal(CLICK_ACTIONS.NO_ACTION);
          }}
        />
        <ViewRemunerationDetails user={remunerationDetails} />
        {getCommentAndAction()}
        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default ViewRemunerationModal;
